import React from 'react';

import { Table2 } from '@.partials';
import { Pagination } from '@.ui';

import { storeClusterDetailStoreSelectors } from '../../../model/ClusterStoreDetailStore';
import { ClusterStoreListModel } from '../../../model/ClusterStoreListModel';
import S from './ClusterStoreDetailList.module.scss';

export const ClusterStoreDetailList = () => {
    const stores = storeClusterDetailStoreSelectors.use.stores();
    const pagination = storeClusterDetailStoreSelectors.use.pagination();

    const setPagination = storeClusterDetailStoreSelectors.use.setPagination();

    const onChangePage = (nextPage: number) => {
        setPagination({ page: nextPage });
    };

    return (
        <div className={S.root}>
            <Table2<any, ClusterStoreListModel[]> data={stores}>
                {{
                    items: [
                        (item) => ({
                            name: 'Name of stores',
                            content: item.storeName,
                        }),
                        (item) => ({
                            name: 'Company',
                            content: item.companyName,
                        }),
                        (item) => ({
                            name: 'Number of stations/devices',
                            content: `${item.stationsCount}/${item.devicesCount}`,
                        }),
                    ],
                }}
            </Table2>

            <Pagination current={pagination.page} last={pagination.last_page} changePage={onChangePage} />
        </div>
    );
};
